
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

const OptimizedTableHeader = () => {
  return (
    <TableHeader>
      <TableRow className="bg-gradient-to-r from-slate-50 to-blue-50 border-b-2 border-slate-200">
        <TableHead className="min-w-[22rem] font-bold text-slate-800 py-3 px-4">Application Details</TableHead>
        <TableHead className="min-w-[15rem] font-bold text-slate-800 text-center py-3 px-3 whitespace-nowrap">Overdue Amount</TableHead>
        <TableHead className="min-w-[6.5rem] font-bold text-slate-800 text-center py-3 px-3 whitespace-nowrap">Status</TableHead>
        <TableHead className="min-w-[7.5rem] font-bold text-slate-800 text-center py-3 px-3 whitespace-nowrap">Date</TableHead>
        <TableHead className="min-w-[8.5rem] font-bold text-slate-800 text-center py-3 px-3 whitespace-nowrap">Amount Collected</TableHead>
        <TableHead className="min-w-[13rem] w-56 font-bold text-slate-800 py-3 px-3 whitespace-nowrap">Recent Comments</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default OptimizedTableHeader;
